<template>
  <div class="monitorlog">
    <el-row class="row-title">
      <el-col :span="2">
        <kt-button
          label="添加"
          type="primary"
          v-if="isMonitor"
          @click="handleAdd"
        />
      </el-col>
      <el-col :span="2" align="right" style="margin-right: 5px">
        <kt-button
          label="上一天"
          type="primary"
          @click="handlePrevDay"
        />
      </el-col>
      <el-col :span="4">
        <el-date-picker
          :editable="false"
          :clearable="false"
          v-model="dataTime"
          type="date"
          placeholder="请选择日期"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
          @change="filterList"
        ></el-date-picker>
      </el-col>
      <el-col :span="2">
        <kt-button
          label="下一天"
          type="primary"
          @click="handleNextDay"
        />
      </el-col>
    </el-row>
    <el-row>
      <!--表格内容栏-->
      <el-table
        :data="filterColumns"
        border
        style="width: 100%; margin-top: 10px"
        :row-style="tableRowStyle"
        :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
        :header-cell-style="tableHeaderColor"
      >
        <el-table-column
          prop="oldName"
          :label="monitor.name"
          width="180"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="period"
          :label="monitor.time"
          width="180"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="place"
          :label="monitor.place"
          width="180"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="event"
          :label="monitor.event"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="reason"
          :label="monitor.reason"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="handle"
          :label="monitor.handle"
          align="center"
        ></el-table-column>
        <el-table-column
          v-if="isMonitor"
          :label="monitor.operation"
          align="center"
        >
          <template slot-scope="scope">
            <a class="curcor" @click="fixLog(scope.row)">
              <img src="@/assets/beadhouse/xiugai_icon_1.png" />
            </a>
            <a class="curcor" @click="deleList(scope.row)">
              <img src="@/assets/beadhouse/shanchu_icon.png" />
            </a>
          </template>
        </el-table-column>
        <el-table-column
          prop="userName"
          :label="monitor.userName"
          align="center"
        ></el-table-column>
      </el-table>
    </el-row>
    <!-- 添加班长日志和修改班长日志的dialog模态框-->
    <el-dialog
      class="monitorLogdialog"
      :title="operation ? monitor.addMonitor : monitor.fixMonitor"
      width="45%"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      @close="closeDialog"
    >
      <el-form
        :model="dataForm"
        label-width="100px"
        :rules="dataFormRules"
        ref="dataForm"
        label-position="right"
      >
        <el-row>
          <el-col :span="10">
            <el-form-item :label="monitor.name + ':'" prop="oldName">
              <el-autocomplete
                v-model.trim="dataForm.oldName"
                auto-complete="off"
                placeholder="请选择老人"
                style="width: 100%"
                :fetch-suggestions="querySearchAsync"
                @select="handleOlderSelect"
                :disabled="!operation"
              ></el-autocomplete>
            </el-form-item>
          </el-col>
          <el-col :span="14">
            <el-form-item :label="monitor.time + ':'" prop="date">
              <el-date-picker
                :editable="false"
                :clearable="false"
                v-model="dataForm.date"
                type="date"
                style="width: 90%"
                :placeholder="monitor.placeChose"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                disabled
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item
              :label="monitor.userName + ':'"
              prop="responsibilityMan"
            >
              <el-autocomplete
                v-model.trim="dataForm.responsibilityMan"
                auto-complete="off"
                :placeholder="monitor.placeHolder"
                style="width: 100%"
                :fetch-suggestions="querynurse"
                @select="SelectNurse"
                :disabled="!operation"
              ></el-autocomplete>
            </el-form-item>
          </el-col>
          <el-col :span="14" style="display: flex">
            <el-form-item :label="monitor.timeHorizon + ':'" prop="timeStart">
              <el-time-picker
                v-model="dataForm.timeStart"
                value-format="HH:mm:ss"
                format="HH:mm:ss"
                style="width: 120px"
              ></el-time-picker>
            </el-form-item>
            <el-form-item
              class="formitem"
              label="至"
              label-width="20px"
              prop="timeEnd"
            >
              <el-time-picker
                v-model="dataForm.timeEnd"
                value-format="HH:mm:ss"
                format="HH:mm:ss"
                style="width: 120px"
              ></el-time-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="monitor.place + ':'" prop="site">
          <el-input
            v-model.trim="dataForm.site"
            type="textarea"
            :rows="2"
            auto-complete="off"
            placeholder
            style="width: 95%"
            maxlength="32"
          ></el-input>
        </el-form-item>
        <el-form-item :label="monitor.event + ':'" prop="occurrence">
          <el-input
            v-model.trim="dataForm.occurrence"
            type="textarea"
            :rows="3"
            auto-complete="off"
            placeholder
            style="width: 95%"
            maxlength="256"
          ></el-input>
        </el-form-item>
        <el-form-item :label="monitor.reason + ':'" prop="reason">
          <el-input
            v-model.trim="dataForm.reason"
            type="textarea"
            :rows="3"
            auto-complete="off"
            placeholder
            style="width: 95%"
            maxlength="256"
          ></el-input>
        </el-form-item>
        <el-form-item :label="monitor.handle + ':'" prop="howToHandle">
          <el-input
            v-model.trim="dataForm.howToHandle"
            type="textarea"
            :rows="3"
            auto-complete="off"
            placeholder
            style="width: 95%"
            maxlength="256"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button type="primary" @click.native="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click.native="submitForm">确定</el-button>
      </div>
    </el-dialog>
    <el-pagination
      class="center-pg fenye"
      ref="pagination"
      background
      @current-change="handleCurrentChange"
      :page-size="10"
      layout="total, prev, pager, next"
      align="center"
      :total="totalAll"
    ></el-pagination>
  </div>
</template>
<script>
import KtTable from "@/components/KtTable";
import KtButton from "@/components/KtButton";
import util from "@/utils/util.js";
export default {
  name: "MonitorLog",
  components: { KtTable, KtButton },
  data() {
    var checkTimeEnd = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("不能为空"));
      }
    };
    return {
      isMonitor: Boolean, //判断是否是班长
      monitor: {
  lastDay: "上一天",
  nextDay: "下一天",
  name: "姓名",
  time: "时间",
  place: "地点",
  event: "发生事件",
  reason: "原因",
  handle: "如何处理",
  operation: "操作",
  userName: "负责人",
  addMonitor: "添加班长日志",
  fixMonitor: "修改班长日志",
  placeHolder: "请选择",
  placeChose: "选择时间",
  timeHorizon: "时间范围",
  to: "至",
  timeStart: "开始时间",
  timeOver: "结束时间",
  choseTime: "请选择时间范围",
  place: "地点",
  choseDate: "选择日期"
}, //引入中文字符
      dataTime: util.formatDate.format(new Date(), "yyyy-MM-dd"), //时间
      //dialog的配置
      operation: true,
      dialogVisible: false,
      dataForm: {
        oldName: "",
        date: util.formatDate.format(new Date(), "yyyy-MM-dd"),
        responsibilityMan: "", //负责人
        timeHorizon: "", //时间范围
        timeStart: "",
        timeEnd: "",
        site: "", //地点
        occurrence: "", //事件
        reason: "", //原因
        howToHandle: "", //如何处理
      },
      dataFormRules: {
        oldName: [
          { required: true, message: "不能为空", trigger: "change" }, //是否必填 //规则  //何事件触发
        ],
        //date: [{ required: true, message: "不能为空", trigger: "change" }],
        responsibilityMan: [
          { required: true, message: "不能为空", trigger: "change" },
        ],
        timeStart: [{ required: true, message: "不能为空", trigger: "change" }],
        timeEnd: [{ validator: checkTimeEnd, trigger: "change" }],
        site: [
          { required: true, message: "不能为空", trigger: "blur" },
          { min: 1, max: 32, message: "长度在 1到 32 个字符" },
        ],
        occurrence: [
          { required: true, message: "不能为空", trigger: "blur" },
          { min: 1, max: 256, message: "长度在 1到 256 个字符" },
        ],
        reason: [
          { required: true, message: "不能为空", trigger: "blur" },
          { min: 1, max: 256, message: "长度在 1到 256 个字符" },
        ],
        howToHandle: [
          { required: true, message: "不能为空", trigger: "blur" },
          { min: 1, max: 256, message: "长度在 1到 256 个字符" },
        ],
      },
      dataFormLoading: false,
      filterColumns: [], //所有数据
      nurseList: [], //护工信息
      oldmanList: [], //老人组
      oldManId: "", //老人id
      nurseid: "", //负责人id
      fixLogid: 0, //修改当前列的id
      pageNum: 1,
      pageSize: 10,
      totalAll: 0, //分页总数
    };
  },
  methods: {
    //修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    //修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
      }
    },
    //上一天
    handlePrevDay() {
      // 获得当前日期
      var doday = new Date(this.dataTime);
      doday = Date.parse(doday);
      // 将当前日期减去1天的时间
      doday = doday - 1000 * 60 * 60 * 24;
      // timeFormat()日期格式化
      var nowDate = util.formatDate.format(new Date(doday));
      // 获得value
      this.dataTime = nowDate;
      this.findPage();
    },

    //下一天
    handleNextDay() {
      // 获得当前日期
      var doday = new Date(this.dataTime);
      doday = Date.parse(doday);
      // 将当前日期加上1天的时间
      doday = doday + 1000 * 60 * 60 * 24;
      // timeFormat()日期格式化
      var nowDate = util.formatDate.format(new Date(doday));
      // 获得value
      this.dataTime = nowDate;
      this.findPage();
    },

    //判断是否是班长
    findIsMonitor() {
      this.$postForm("omc/group/getUserLongDetail").then((res) => {
        this.isMonitor = res.result.monitor;
        if (!this.isMonitor) {
          this.$message({
            message: "非班长用户不能添加班长日志",
            type: "error",
          });
        }
      });
    },

    //根据时间查询表格数据
    filterList(val) {
      this.dataTime = val;
      this.findPage();
    },
    //翻页
    handleCurrentChange(val) {
      this.pageNum = val;
      this.findPage();
    },
    //表格的添加
    handleAdd() {
      this.dialogVisible = true;
      this.operation = true;
    },

    /* 
      关闭弹窗
    */
    closeDialog() {
      this.$refs["dataForm"].resetFields();
    },
    /* 
    模糊查询老人
    */
    querySearchAsync(queryString, cb) {
      console.log(queryString, "queryString");
      let nursingGroupId = sessionStorage.getItem("nursingGroupId");
      let param = {
        oldName: this.dataForm.oldName,
        nursingGroupId: nursingGroupId,
      };
      this.$postJson("omc/monitorlog/selectByName", param).then((res) => {
        this.oldmanList = res.result;
        var list = [{}];
        if (res.result.length > 0) {
          for (let i of res.result) {
            i.value = i.oldName; //将想要展示的数据作为value
          }
          list = res.result;
          cb(list);
        } else {
          let arr = [];
          arr.push({
            uuid: "-1",
            value: "",
          });
          cb(arr);
          setTimeout(() => {
            this.dataForm.oldName = "";
          }, 1000);
        }
      });
    },

    /* 
      根据模糊查询老人返回老人id
    */
    handleOlderSelect(item) {
      this.oldManId = item.oldmanId;
    },

    /* 
    模糊查询护士负责人
   */
    querynurse(queryString, cb) {
      let param = {
        name: queryString,
      };
      this.$postJson("omc/group/selectNursingShowAll", param).then((res) => {
        this.nurseList = res.result;
        var list = [{}];
        if (res.result) {
          for (let i of res.result) {
            i.value = i.realName; //将想要展示的数据作为value
          }
          list = res.result;
          cb(list);
        } else {
          let arr = [];
          arr.push({
            uuid: "-1",
            value: "",
          });
          cb(arr);
          setTimeout(() => {
            this.dataForm.responsibilityMan = "";
          }, 1000);
        }
      });
    },
    /* 
      根据负责人获取负责人id
    */
    SelectNurse(item) {
      this.nurseid = item.userId;
      this.dataForm.responsibilityMan = item.realName;
    },

    //查询列表
    findPage(data) {
      let param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        date: this.dataTime,
        nursingGroupId: sessionStorage.getItem("nursingGroupId") !=null ? sessionStorage.getItem("nursingGroupId") !=null: sessionStorage.getItem("groupId"),
      };
      this.$postJson("omc/monitorlog/selectShowAll", param)
        .then((res) => {
          this.filterColumns = res.result.list;
          this.totalAll = Number(res.result.total);
          setTimeout(() => {
            this.loading = false;
          }, 500);
        })
        .then(data != null ? data.callback : "");
    },

    // 分页刷新数据
    refreshPageRequest(data) {
      console.log(data);
      this.pageRequest.pageNum = data;
      this.findPage();
    },

    // 新增和编辑提交数据
    submitForm() {
      //校验表单

      if (
        this.dataForm.oldName &&
        this.dataForm.date &&
        this.dataForm.responsibilityMan &&
        this.dataForm.timeStart &&
        this.dataForm.timeEnd &&
        this.dataForm.site &&
        this.dataForm.occurrence &&
        this.dataForm.reason &&
        this.dataForm.howToHandle
      ) {
        //校验表单
        let nursingGroupId  =  sessionStorage.getItem("nursingGroupId") !=null ? sessionStorage.getItem("nursingGroupId") !=null: sessionStorage.getItem("groupId");
        //筛选正确的护工姓名上传 by xiang 2019-11-28
        let nurse = this.nurseList.filter((item) => {
          return item.userId == this.nurseid;
        });
        let oldNames = this.oldmanList.filter((item) => {
          return item.oldmanId == this.oldManId;
        });
        //提交表单
        let param = {
          //oldName:this.dataForm.oldName,
          // userName:nurse[0].realName,
          oldManId: this.oldManId,
          userId: Number(this.nurseid),
          nursingGroupId: Number(nursingGroupId),
          period: this.dataForm.timeStart + "-" + this.dataForm.timeEnd,
          date: this.dataForm.date,
          place: this.dataForm.site,
          event: this.dataForm.occurrence,
          reason: this.dataForm.reason,
          handle: this.dataForm.howToHandle,
        };
        if (!this.operation) {
          param.id = this.fixLogid;
          param.userName = this.dataForm.responsibilityMan;
          param.oldName = this.dataForm.oldName;
        } else {
          param.userName = nurse[0].realName;
          param.oldName = oldNames[0].oldName;
        }
        this.$postJson(
          this.operation
            ? "omc/monitorlog/mLogAdd"
            : "omc/monitorlog/updateById",
          param
        ).then((res) => {
          if (res.code == 200) {
            this.$message({ message: res.message, type: "success" });
            this.findPage(); //重新渲染页面
            this.$nextTick(() => {
              this.dialogVisible = false; //关闭弹框
            });
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        });
      } else {
        this.$message({ message: "必填项不能为空", type: "error" });
      }
    },

    //修改日志
    fixLog(row) {
      console.log(row);
      this.operation = false;
      this.dialogVisible = true;
      this.fixLogid = row.id;
      //数据回显
      this.$nextTick(() => {
        this.nurseid = row.userId;
        this.oldManId = row.oldManId;
        this.dataForm = {
          oldName: row.oldName,
          date: row.date,
          responsibilityMan: row.userName, //负责人
          timeStart: row.period.split("-")[0], //起始时间
          timeEnd: row.period.split("-")[1], //结束时间
          site: row.place, //地点
          occurrence: row.event, //事件
          reason: row.reason, //原因
          howToHandle: row.handle, //如何处理
        };
      });
    },

    //删除当前列
    deleList(row) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let param = {
            id: row.id,
          };
          this.$postForm("omc/monitorlog/mLogDelById", param).then(
            (res) => {
              if (res.code == 200) {
                this.$message({ message: res.message, type: "success" });
                this.findPage(); //重新渲染页面
              } else {
                this.$message({
                  message: "删除失败, " + res.message,
                  type: "error",
                });
              }
            }
          );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },

  mounted() {
    this.findPage();
    // this.findIsMonitor(); //判断是否是班长
  },
};
</script>
<style lang="scss" scoped>
.monitorlog {
  min-width: 1360px;
  min-height: 500px;
  background: #fefefe;
}

.curcor {
  cursor: pointer;
  margin-left: 5px;
  margin-right: 5px;
}
// ::v-deep深度作用选择符
::v-deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}
::v-deep .el-dialog .el-dialog__body {
  padding: 20px 20px 10px 20px !important;
}
</style>
